import styled from 'styled-components';
import {
	MERCHANT_BACKGROUND_COLOR,
	//MERCHANT_LOGO_WHITE,
} from '../../../../utils/env';

interface Opened {
	open: boolean;
}

export const Menu = styled.div<Opened>`
	height: calc(100vh - 60px);
	max-width: ${(props) => (props.open ? '217px' : '100px')};
	min-width: ${(props) => (props.open ? '214px' : '100px')};
	width: 100%;
	background-color: ${(props) =>
		props.open ? MERCHANT_BACKGROUND_COLOR || '#064176' : '#F5F5F5'};
	//margin-right: 12px;

	transition: all 0.4s;
	border-radius: 24px;
	margin-top: 30px;
	margin-bottom: 30px;
	z-index: 20;

	//position:fixed;
`;

export const MenuItems = styled.div<Opened>`
	background-color: ${(props) =>
		props.open ? MERCHANT_BACKGROUND_COLOR || '#064176' : '#F5F5F5'};
	// padding-bottom: 35px;
	//background-color: ${(props) => (props.open ? '#e5e5e5' : '#F5F5F5')};
	border-radius: 24px;
	//margin-left: 10px;
	height: calc(100vh - 60px - 35px);
	overflow-y: scroll;

	::-webkit-scrollbar {
		background: transparent;

		// display:none;

		width: 0;
	}

	&::-webkit-scrollbar-track {
		/*  margin-top:0;
      border-bottom-right-radius: 16px;
      background-image: url("https://i.stack.imgur.com/Pwbuz.png");
    background-repeat: repeat-y;
    background-size: contain;
      */
		// margin-top: 54px;
	}
	&::-webkit-scrollbar-thumb {
		background: transparent;
		border-radius: 20px;
		border: 2.5px solid rgba(0, 0, 0, 0);
		border-right: 5px solid rgba(0, 0, 0, 0);

		background-clip: padding-box;
		max-height: 5px;
		transition: all 0.4s;
	}

	// background-color:#000;
	//min-height: calc( 100vh - 60px );
	//overflow-y: hidden;
	//max-height: calc( 100vh - 60px );
	// overflow-y: scroll;

	max-width: ${(props) => (props.open ? '217px' : '100px')};
	min-width: ${(props) => (props.open ? '210px' : '100px')};
	display: flex;
	flex-direction: column;
	//align-items: center;
	transition: all 0.4s;
	//padding-bottom: 35px;

	a {
		text-decoration: none;
	}

	//z-index:2;
`;

export const MenuHeader = styled.div<Opened>`
	height: 64px;
	width: 100%;
	display: flex;
	//justify-content:center;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	//transition: all 0.4s;
	transition: all 0.4s;
	margin-bottom: 20px;
	margin-top: 10px;
	padding-left:20px;
	padding-right: 20px;
`;

export const MenuImg = styled.img<Opened>`
	//width: ${(props) => (props.open ? '90px' : '32px')};
	// width: 100%;
	height: 32px;
	//margin-left: 40px;
	//margin-left: ${(props) => (!props.open ? '' : '40px')};
	//transition: all 0.4s;
`;

export const MenuItem = styled.button<Props>`
	border: 0;
	cursor: pointer;

	border-radius: 21px;

	height: 42px;
	position: relative;
	box-shadow: ${(props) => (props.active ? '0px 12px 12px #22222229' : 0)};

	background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};
	//background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};

	margin-left: ${(props) => (!props.open ? '24px' : 0)};
	//margin-right: 24px;

	display: ${(props) => (!props.open ? 'flex' : 'flex')};
	flex-direction: row;
	align-items: center;
	padding-left: 16px;
	padding-right: 16px;

	padding-top: 16px;
	padding-bottom: 16px;
	// width: ${(props) => (props.open ? '184px' : '48px')};
	//width: calc(100% - 16px);
	transition: all 0.4s;
	//transition: all 0.4s;

	justify-content: flex-start;

	overflow: hidden;

	text-align: left;

	margin-bottom: 10px;
	margin-left: 10px;
	margin-right: 10px;
	width: calc(100% - 20px);

	.menuGreenDot {
		position: absolute;
		right: 10px;
		background: #28a745;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		display: ${(props) => (props.open && props.active ? 'block' : 'none')};
		//opacity: ${(props) => (props.open && props.active ? 1 : 0)};
		// bottom: calc((42 - 8) / 2) px;
		//transition: all 3s;
	}

	.invoice_menu_icon_on {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;

		display: ${(props) => (props.active || !props.open ? 'block' : 'none')};
	}

	.invoice_menu_icon_off {
		display: ${(props) => (!(props.active || !props.open) ? 'block' : 'none')};

		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
	}

	img {
		width: 19px;
		height: 19px;
		margin-right: 8px;
	}

	svg {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		color: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};
		fill: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		fill: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};

		//transition: all 0.4s;
	}
	p {
		font: ${(props) =>
			props.active
				? 'normal normal 500 14px/19px Roboto'
				: 'normal normal normal 14px/19px Roboto'};
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#033463' : '#ffffff')};
		//font-size: ${(props) => (props.open ? '14px' : 0)};
		//opacity: ${(props) => (props.open ? 1 : 0)};
		//width:0;
		//display: ${(props) => (props.open ? 'block' : 'none')};
		color: ${(props) => (props.open ? '' : 'transparent')};
		//transition: all 0.4s;
		text-transform: capitalize;
	}

	border: 1px solid transparent;

	:hover {
		//background-color: #ffffff;
		background-color: ${(props) =>
			props.active
				? '#ffffff'
				: props.open
				? process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'
				: '#ffffff'};

		border: ${(props) =>
			props.active ? '1px solid transparent' : '1px solid #ffffff'};

		transition: border 0s;

		.menuGreenDot {
			display: ${(props) => (props.active ? 'block' : 'none')};
		}

		svg {
			margin-right: ${(props) => (props.open ? '16px' : '')};
			//transition: all 0.4s;

			width: 16px;
			height: 16px;
			//color: #FFFFFF;
		}
		p {
			font: normal normal 500 14px/19px Roboto;
			font-size: ${(props) => (props.open ? '14px' : 0)};
			//	transition: all 0.4s;

			//color: #09aa36;
			//color: #FFFFFF;
		}
	}
`;


interface MenuItemProps {
	active: boolean;
	open: boolean;
	opened: boolean;
}
export const MenuItemPagamento = styled.button<MenuItemProps>`
	.header_container_pay {
		padding-left: 16px;
		padding-right: 16px;
		display: flex;
		height: 42px;
		background: transparent;
		flex-direction: row;
		align-items: center;
		width: 100%;
		position: relative;
		.menuGreenDot {
			position: absolute;
			right: 10px;
			background: #28a745;
			width: 8px;
			height: 8px;
			border-radius: 4px;
			display: ${(props) => (props.open && props.active ? 'block' : 'none')};
			//opacity: ${(props) => (props.open && props.active ? 1 : 0)};
			// bottom: calc((42 - 8) / 2) px;
			right: 40px;
			//transition: all 3s;
		}

		// justify-content: space-between;
		.open_close_item {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			background: ${({ opened }) => (opened ? '#e3e9ef' : 'transparent')} 0% 0%
				no-repeat padding-box;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			right: 5px;
			top: 5px;

			img {
				width: 15px;
				height: 15px;
			}
			.open_close_item_icon_on {
				display: ${({ opened, active }) =>
					opened || active ? 'block' : 'none'};
				margin: 0;
				transform: ${({ opened }) =>
					opened ? 'matrix(-1, 0, 0, -1, 0, 0)' : 'matrix(1, 0, 0, 1, 0, 0)'};
			}
			.open_close_item_icon_off {
				display: ${({ opened, active }) =>
					!(opened || active) ? 'block' : 'none'};
				margin: 0;
			}
		}
	}

	:hover {
		.open_close_item {
			background: ${({ opened }) => (opened ? '#e3e9ef' : 'rgb(30, 84, 131)')}
				0% 0% no-repeat padding-box;
			.open_close_item_icon_on {
				display: ${({ opened }) => (opened ? 'block' : 'none')};

				// display: none;
				margin: 0;
			}
			.open_close_item_icon_off {
				display: ${({ opened }) => (!opened ? 'block' : 'none')};

				// display: block;
				margin: 0;
			}
		}
	}
	border: 0;
	cursor: pointer;

	border-radius: 21px;

	height: ${({ opened }) => (opened ? 	159 /*120*/ : 42)}px;
	position: relative;
	box-shadow: ${(props) => (props.active ? '0px 12px 12px #22222229' : 0)};

	background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};
	//background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};

	margin-left: ${(props) => (!props.open ? '24px' : 0)};
	//margin-right: 24px;

	display: ${(props) => (props.opened ? 'flex' : 'flex')};
	flex-direction: column;

	padding: 0;

	// width: ${(props) => (props.open ? '184px' : '48px')};
	//width: calc(100% - 16px);
	//transition: all 0.4s;

	justify-content: flex-start;

	overflow: hidden;

	text-align: left;

	margin-bottom: 10px;
	margin-left: 10px;
	margin-right: 10px;
	width: calc(100% - 20px);

	.menuGreenDot {
		position: absolute;
		right: 10px;
		background: #28a745;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		display: ${(props) => (props.open && props.active ? 'block' : 'none')};
		//opacity: ${(props) => (props.open && props.active ? 1 : 0)};
		// bottom: 17px;
		//transition: all 3s;
	}

	.invoice_menu_icon_on {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;

		display: ${(props) => (props.active || !props.open ? 'block' : 'none')};
	}

	.invoice_menu_icon_off {
		display: ${(props) => (!(props.active || !props.open) ? 'block' : 'none')};

		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
	}

	img {
		width: 19px;
		height: 19px;
		margin-right: 8px;
	}

	svg {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		color: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};
		fill: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		fill: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};

		//transition: all 0.4s;
	}
	p {
		font: ${(props) =>
			props.active
				? 'normal normal 500 14px/19px Roboto'
				: 'normal normal normal 14px/19px Roboto'};
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#033463' : '#ffffff')};
		//font-size: ${(props) => (props.open ? '14px' : 0)};
		//opacity: ${(props) => (props.open ? 1 : 0)};
		//width:0;
		//display: ${(props) => (props.open ? 'block' : 'none')};
		color: ${(props) => (props.open ? '' : 'transparent')};
		//transition: all 0.4s;
		text-transform: capitalize;
	}

	border: 1px solid transparent;

	:hover {
		//background-color: #ffffff;
		background-color: ${(props) =>
			props.active
				? '#ffffff'
				: props.open
				? process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'
				: '#ffffff'};

		border: ${(props) =>
			props.active ? '1px solid transparent' : '1px solid #ffffff'};

		transition: border 0s;

		.menuGreenDot {
			display: ${(props) => (props.active ? 'block' : 'none')};
		}

		svg {
			margin-right: ${(props) => (props.open ? '16px' : '')};
			//transition: all 0.4s;

			width: 16px;
			height: 16px;
			//color: #FFFFFF;
		}
		p {
			font: normal normal 500 14px/19px Roboto;
			font-size: ${(props) => (props.open ? '14px' : 0)};
			//	transition: all 0.4s;

			//color: #09aa36;
			//color: #FFFFFF;
		}
	}
`;

export const MenuSubItem = styled.button<MenuItemProps>`
	border: 0;
	cursor: pointer;

	height: 36px;
	position: relative;
	padding-left: 16px;

	.menuGreenDot {
		position: absolute;
		right: 10px;
		background: #28a745;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		display: ${(props) => (props.open && props.active ? 'block' : 'none')};
		//opacity: ${(props) => (props.open && props.active ? 1 : 0)};
		bottom: calc((36 - 8) / 2) px;
		//transition: all 3s;
	}

	background: ${(props) => (props.active ? '#E3E9EF80' : 'transparent')};
	//background: ${(props) => (props.active ? '#FFFFFF' : 'transparent')};

	//margin-right: 24px;

	display: ${(props) => (props.opened ? 'flex' : 'none')};
	flex-direction: row;
	align-items: center;
	/*padding-left: 16px;
	padding-right: 16px;

	padding-top: 16px;
	padding-bottom: 16px;*/
	// width: ${(props) => (props.open ? '184px' : '48px')};
	//width: calc(100% - 16px);
	transition: all 0.4s;
	//transition: all 0.4s;

	justify-content: flex-start;

	overflow: hidden;

	text-align: left;

	/*margin-bottom: 10px;
	margin-left: 10px;
	margin-right: 10px;*/
	width: calc(100%);

	.menuGreenDot {
		position: absolute;
		right: 10px;
		background: #28a745;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		display: ${(props) => (props.open && props.active ? 'block' : 'none')};
		//opacity: ${(props) => (props.open && props.active ? 1 : 0)};
		// bottom: 17px;
		//transition: all 3s;
	}

	.invoice_menu_icon_on {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;

		display: ${(props) => (props.active || !props.open ? 'block' : 'none')};
	}

	.invoice_menu_icon_off {
		display: ${(props) => (!(props.active || !props.open) ? 'block' : 'none')};

		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
	}

	img {
		width: 19px;
		height: 19px;
		margin-right: 8px;
	}

	svg {
		margin-right: ${(props) => (props.open ? '16px' : '')};
		min-width: 16px;
		min-height: 16px;
		width: 16px;
		height: 16px;
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		color: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};
		fill: ${(props) => (props.active ? '#93CC2F' : '#ffffff')};
		fill: ${(props) =>
			props.open
				? ''
				: props.active
				? '#93CC2F'
				: process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR || '#064176'};

		//transition: all 0.4s;
	}
	p {
		font: ${(props) =>
			props.active
				? 'normal normal 500 14px/19px Roboto'
				: 'normal normal normal 14px/19px Roboto;'};
		//color: ${(props) => (props.active ? '#09aa36' : '#9f9f9f')};
		color: ${(props) => (props.active ? '#092A60' : '#676767')};
		//font-size: ${(props) => (props.open ? '14px' : 0)};
		//opacity: ${(props) => (props.open ? 1 : 0)};
		//width:0;
		//display: ${(props) => (props.open ? 'block' : 'none')};
		color: ${(props) => (props.open ? '' : 'transparent')};
		//transition: all 0.4s;
		text-transform: capitalize;
	}

	border: 1px solid transparent;

	:hover {
		//background-color: #ffffff;
		background-color: ${(props) =>
			props.active ? '#E3E9EF80' : props.open ? 'transparent' : '#222222'};

		transition: border 0s;

		.menuGreenDot {
			display: ${(props) => (props.active ? 'block' : 'none')};
		}

		svg {
			margin-right: ${(props) => (props.open ? '16px' : '')};
			//transition: all 0.4s;

			width: 16px;
			height: 16px;
			//color: #FFFFFF;
		}
		p {
			font: normal normal 500 14px/19px Roboto;
			font-size: ${(props) => (props.open ? '14px' : 0)};
			color: ${(props) => (props.active ? '#092A60' : '#222222')};

			//	transition: all 0.4s;

			//color: #09aa36;
			//color: #FFFFFF;
		}
	}
`;
interface Props {
	active: boolean;
	open: boolean;
}

export const MenuText = styled.p`
	text-align: left;

	letter-spacing: 0px;

	opacity: 1;
	margin: 0;
	// color:#033463;
`;

export const UserContainer = styled.div<Opened>`
	position: absolute;
	bottom: 40px;
	left: ${(props) => (props.open ? '40px' : '24px')};

	display: flex;
	flex-direction: column;

	p {
		margin: 0;
	}

	align-items: ${(props) => (props.open ? '' : 'center')};

	svg {
		width: 16px;
		height: 19px;
		color: #9f9f9f;
		margin-top: 8px;
	}
`;

export const UserName = styled.p`
	text-align: left;
	font: normal normal 500 14px/19px Roboto;
	letter-spacing: 0px;
	color: #676767;
	text-transform: capitalize;
`;
export const UserEmail = styled.p`
	text-align: left;
	font: normal normal normal 12px/16px Roboto;
	letter-spacing: 0px;
	color: #676767;
	opacity: 1;
`;

export const LogOutButton = styled.button`
	background: #ffffff 0% 0% no-repeat padding-box;
	border: 1px solid #09aa36;
	border-radius: 10px;
	opacity: 1;

	max-width: 72px;
	max-height: 32px;

	text-align: center;
	font: normal normal 500 14px/19px Roboto;
	letter-spacing: 0px;
	color: #09aa36;
	opacity: 1;
	padding-top: 6px;
	padding-bottom: 6px;
	margin-top: 12px;
`;

export const UserIcon = styled.div`
	background: #09aa36 0% 0% no-repeat padding-box;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	p {
		text-align: center;
		font: normal normal 500 20px/26px Roboto;
		letter-spacing: 0px;
		color: #ffffff;
		vertical-align: middle;
		margin: 0;
		text-transform: uppercase;
	}
`;

export const Footer = styled.div<Opened>`
	position: sticky;
	position: -webkit-sticky;
	bottom: 35px;
	width: ${(props) => (props.open ? 'calc(100%)' : 0)};
	//margin-left: 10px;
	//margin-right: 10px;
	overflow: hidden;

	background: ${MERCHANT_BACKGROUND_COLOR || '#064176'} 0% 0% no-repeat
		padding-box;
	border-radius: 18px;
	height: 45px;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.4s;

	padding: 10px;

	img {
		color: #000;
		height: 15px;
	}

	.menu_footer_item {
		background: #ff671f 0% 0% no-repeat padding-box;
		border-radius: 18px;
		height: 35px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;
